
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import {
		apiStorageIndex,
		apiStorageSetup,
	} from '@/api/setting'
	@Component({
		components: {},
	})
	export default class Storage extends Vue {
		/** S Data **/
		// วิธีการจัดเก็บ
		engine = "" // ชื่อเครื่องมือจัดเก็บข้อมูล：local-ท้องถิ่น，qiniu-ฉินหยุน,aliyun-อาลีบาบา คลาวด์OSS,qcloud-เทนเซ็นต์ คลาวด์OS:
		form = {
			bucket: '',
			access_key: '',
			secret_key: '',
			domain: '',
			region: '', // ความต้องการของ Tencent Cloud
			status: 0,
		}

		formRules = {
			bucket: [{
				required: true,
				message: 'กรุณากรอกชื่อพื้นที่เก็บข้อมูล',
				trigger: 'blur'
			}],
			access_key: [{
				required: true,
				message: 'กรุณาเข้าACCESS_KEY',
				trigger: 'blur'
			}],
			secret_key: [{
				required: true,
				message: 'กรุณาเข้าSECRET_KEY',
				trigger: 'blur'
			}],
			domain: [{
				required: true,
				message: 'กรุณากรอกชื่อโดเมนช่องว่าง',
				trigger: 'blur'
			}],
			region: [{
				required: true,
				message: 'กรุณาเข้าREGION',
				trigger: 'blur'
			}],
		}
		$refs!: {
			formRef: any
		}
		/** E Data **/

		/** S Methods **/
		onSubmit() {
			// ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
			this.$refs.formRef.validate((valid: boolean): any => {
				if (!valid) return;
				// ขอส่ง
				 apiStorageSetup({
					...this.form,
					engine: this.engine
				})
				.then((res: any) => {
					setTimeout(() => this.$router.go(-1), 500)			
					//this.$message.success('บันทึกเรียบร้อยแล้ว!')
				})
				.catch((res: any) => {
					console.log(res)
					//this.$message.error('บันทึกล้มเหลว!')
				})
				// setTimeout(()=> {
				// 	this.getStorageIndex()
				// }, 100)
			})
		}

		// รับการกำหนดค่าเครื่องยนต์
		getStorageIndex() {
			apiStorageIndex({engine: this.engine})
			.then((res: any) => {
				console.log(res)
				this.form = res
			})
			.catch((res: any) => {
				console.log(res)
				//this.$message.error('ไม่สามารถรับได้，โปรดลองอีกครั้ง!')
			})
		}
		/** E Methods **/
		/** S Life Cycle **/
		created() {
			const query: any = this.$route.query
			if (query.engine) this.engine = query.engine
			this.getStorageIndex()
		}
		/** E Life Cycle **/
	}
